import React, { useRef, ChangeEvent, useEffect, useState } from 'react';
import './index.less'

interface ActivityTagPropsRule {
  activityAbbr: string
  activityPriceDesc: string
  type: number
  className?: string
  priceLabelClassName?: string
  disabled?: boolean
  showBackUpText?: boolean
}

const ActivityTag = (props: ActivityTagPropsRule) => {
  const { activityPriceDesc, activityAbbr, type, className, priceLabelClassName, disabled = false, showBackUpText = true } = props

  const renderActivityTagByType = () => {
    if (!activityAbbr) return showBackUpText ? <span className={`priceLabel ${priceLabelClassName ? priceLabelClassName : ''}`}>预估单价</span> : null;

    switch (type) {
      case 1:
        return (
          <div className={`ActivityTagContainer ${disabled ? 'disabled' : ''} ${className}`}>
            <div
              className="ActivtyTagRadiu"
              style={{
                borderRadius: !activityPriceDesc ? 2 : undefined,
                background: disabled ? '#BDBDBD' : 'linear-gradient(167.38deg, rgba(126, 139, 163, 1),rgba(155, 170, 199, 1))'
              }}
            >
              <div
                className='exclusiveLeft'
              >
                <span className='exclusiveText'>{activityAbbr}</span>
              </div>
            </div>
            {
              !!activityPriceDesc
              && <div className='exclusiveRight'>
                <span className='exclusiveCutText'>{activityPriceDesc}</span>
              </div>
            }
          </div>
        );
      case 2:
        return (
          <div className={`ActivityTagContainer ${disabled ? 'disabled' : ''} ${className}`}>
            <div
              className="ActivtyTagRadiu"
              style={{
                borderRadius: !activityPriceDesc ? 2 : undefined,
                background: disabled ? '#BDBDBD' : 'linear-gradient(167.38deg, rgba(194, 158, 85, 1),rgba(217, 192, 143, 1))'
              }}
            >
              <div
                className='actLeft'
              >
                <span className='actText'>{activityAbbr}</span>
              </div>
            </div>
            {
              !!activityPriceDesc
              && <div className='actRight'>
                <span className='actCutText'>{activityPriceDesc}</span>
              </div>
            }
          </div>
        );
      default:
        return (
          <div className={`ActivityTagContainer ${disabled ? 'disabled' : ''} ${className}`}>
            <div
              className="ActivtyTagRadiu"
              style={{
                borderRadius: !activityPriceDesc ? 2 : undefined,
                background: disabled ? '#BDBDBD' : 'linear-gradient(167.38deg, rgba(126, 139, 163, 1),rgba(155, 170, 199, 1))'
              }}
            >
              <div
                className='exclusiveLeft'
              >
                <span className='exclusiveText'>{activityAbbr}</span>
              </div>
            </div>
            {
              !!activityPriceDesc
              && <div className='exclusiveRight'>
                <span className='exclusiveCutText'>{activityPriceDesc}</span>
              </div>
            }
          </div>
        );
    }
  }
  return (
    renderActivityTagByType()
  );
}

export default ActivityTag